export const PLUGIN_POLLING_INTERVAL = 10000; // 10 second
